import React from "react";

const Footer: React.FC = () =>{
    return(
    <div className="container">
        <footer className="py-3 my-4">
        <p className="text-center text-body-secondary">© {new Date().getFullYear()} Joshua Hermoso</p>
  </footer>
</div>
    )
}

export default Footer